import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-admin-menu',
  templateUrl: './content-admin-menu.component.html',
  styleUrls: ['./content-admin-menu.component.css']
})
export class ContentAdminMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
